export const currencies = {
  EUR: {
    symbol: '€',
  },
  PLN: {
    symbol: 'zł',
  },
};

export const countries = {
  LT: {
    currency: 'EUR',
  },
  PL: {
    currency: 'PLN',
  },
};

export const cities = {
  vilnius: {
    code: 'vilnius',
    name: 'Vilnius',
    country: 'LT',
    currency: 'EUR',
    defaultAreaRadius: 20000,
    language: 'lt',
    location: { lat: 54.687157, lng: 25.279652 },
  },
  kaunas: {
    code: 'kaunas',
    name: 'Kaunas',
    country: 'LT',
    currency: 'EUR',
    defaultAreaRadius: 20000,
    language: 'lt',
    location: { lat: 54.898521, lng: 23.903597 },
    toggle: 'app.enableKaunasLocation',
  },
  klaipeda: {
    code: 'klaipeda',
    name: 'Klaipėda',
    country: 'LT',
    currency: 'EUR',
    language: 'lt',
    defaultAreaRadius: 20000,
    location: { lat: 55.703297, lng: 21.144279 },
    toggle: 'app.enableKlaipedaLocation',
  },
  warsaw: {
    code: 'warsaw',
    name: 'Warszawa',
    country: 'PL',
    currency: 'PLN',
    language: 'pl',
    defaultAreaRadius: 20000,
    location: { lat: 52.237049, lng: 21.017532 },
    toggle: 'app.enableWarsawLocation',
  },
};
